import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';
import { useAuth } from '@/contexts/useAuth';
import { getSocket } from '@/hooks/useRealtimeSync';
import { refreshAccessPolicyOnClient, ACCESS_POLICY_CHANGED_EVENT } from '@/lib/accessPolicySync';

export function AccessPolicySync() {
  const queryClient = useQueryClient();
  const { isAuthenticated, loading, getSession, setSession } = useAuth();

  useEffect(() => {
    if (loading || !isAuthenticated) return;
    const socket = getSocket();
    const handlePolicyChanged = () => {
      void refreshAccessPolicyOnClient({
        fetchMe: () => api.access.me(),
        getSession,
        setSession,
        clearQueries: () => queryClient.clear(),
      }).catch(() => {});
    };
    socket.on(ACCESS_POLICY_CHANGED_EVENT, handlePolicyChanged);
    return () => {
      socket.off(ACCESS_POLICY_CHANGED_EVENT, handlePolicyChanged);
    };
  }, [loading, isAuthenticated, getSession, setSession, queryClient]);

  return null;
}
